import { ChangeDetectorRef, Component, Inject, Injector, OnInit } from "@angular/core";
import { TuiDialogContext, TuiDialogService } from "@taiga-ui/core";
import {
  PolymorpheusComponent,
  POLYMORPHEUS_CONTEXT,
} from "@tinkoff/ng-polymorpheus";
import { NgxSpinnerService } from "ngx-spinner";
import { ApiService } from "src/app/core/services/shared/api.service";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";
import { Answer } from "virtue-form";

export interface searchCollegeList {
  list: Array<any>;
}
export interface stateAnswer {
  stateCode: string;
  stateInOut: string;
}

export interface AffinitySelected {
  affinityoptions: affinityoptions;
  AffinityQuestionSelectedAmount: string;
}

export interface affinityoptions {
  AffinityQuestionSelectedOption: string;
}

export interface IntrestPageAnswer {
  defaultLabel: any;
  defaultValue: string;
  list: Array<any>;
}

export interface CollegeName {
  key: string;
  value: string;
  stateCode: String;
}

export interface AffinityQuestion {
  option: string;
  amount: number;
}

@Component({
  selector: "app-college-name-search-box",
  templateUrl: "./college-name-search-box.component.html",
  styleUrls: ["./college-name-search-box.component.scss"],
})
export class CollegeNameSearchBoxComponent implements OnInit {
  selctedCollege: any;
  isLoadingData=false;
  selectedUniversityList: any[] = [];
  selectedUniversity = [];
  isSelectedUniversityItems = [true, true, true, true, true];
  universitySelectedValueMap: Map<string, string> = new Map();
  interestPageAnswerMap: Map<string, IntrestPageAnswer> = new Map();
  answerMap!: Map<Number, Answer>;
  affinityQuestionAnswer: Map<string, any> = new Map();
  mergerdUniversityList: any[] = []; // new variable
  searchAutoCompleteList: Array<any> = [];

  searchSelectedCollegeList: Array<any> = [];
  changedCollege: Array<any> = [];

  currentCollegeName:string="";

  yearWiseAffinityQuestion: any[] = [];
  StateInOutMap: Map<string, stateAnswer> = new Map();
  studentInputdata: any;
  setToggleIn = [false, undefined, undefined, undefined, undefined];
  domesileStatus: string[] = [];
  residencyStatus: string[] = [];
  selectedStates = [];
  index: number;
  modelvalue: Array<CollegeName> = [];
  selctedCollegeIndex: number;

  ocrResponseListTotal: any = [];

  constructor(
    private cdr: ChangeDetectorRef,
    private spinnerService: NgxSpinnerService,
    public apiService: ApiService,

    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<any, any>,
    public globalvar: GlobalVarService
  ) {
    const dialog = document.querySelector('tui-dialog');
    dialog.classList.add('replace-college');
    

  }

  ngOnInit(): void {
    this.index = this.context.data.index;
    let searchAutoCompleteList = [];
    let searchclgList = this.context.data.searchAutoCompleteList;
    this.searchSelectedCollegeList=this.context.data.searchAutoCompleteList;
    this.changedCollege=this.context.data.changedCollege;
    this.currentCollegeName=this.context.data?.changedCollege?.dropDownData?.name;
  //   if (this.globalvar.searchSelectedCollegeList.length==0) {
  //  this.globalvar.searchSelectedCollegeList=searchclgList;
  //   }
  //   else{
  //     searchclgList=this.globalvar.searchSelectedCollegeList;
  //   }
   searchclgList.forEach((key,index) => {
      let obj = {
        key: searchclgList[index]?.dropDownData?.ipedsId,
        value: searchclgList[index]?.dropDownData?.name
        // stateCode: searchclgList[key].stateCode.toLowerCase(),
      };
      searchAutoCompleteList.push(obj);
    });
    this.searchAutoCompleteList = searchAutoCompleteList;

    if (this.globalvar.answerMap) {
      this.studentInputdata = this.globalvar.answerMap.get(6);
      this.answerMap = this.globalvar.answerMap;
    }
  }

  selectCollege(item: any) {
    this.selctedCollege = item;
    this.selectUniversity("", this.index, item.ipedsId);
  }

  changeCollege() {
    // this.apiService.submitForm(this.answerMap, 0, false, "TOP5", (resp) => {
    //   let formSubmitId = resp["id"];
    //   let selectedColleges = [];
    //   let StudentSelectedCollege = [];
    //   for (let index = 0; index < this.selectedUniversityList.length; index++) {
    //     let affinityQuestion = null;
    //     let name = this.selectedUniversityList[index]["name"];
    //     let stateCode = this.selectedStates[index];
    //     let ipedsId = this.selectedUniversityList[index]["ipedsId"];
    //     affinityQuestion =
    //       this.selectedUniversityList[index]["yearWiseAffinityQuestion"][
    //         "2022"
    //       ];

    //     if (affinityQuestion != undefined && affinityQuestion) {
    //       affinityQuestion = affinityQuestion;
    //     }
    //     let awardLetterResultId = "";
    //     if (this.ocrResponseListTotal[index] != undefined) {
    //       awardLetterResultId = this.ocrResponseListTotal[index].id;
    //     }

    //     let domicileAndResidency =
    //       this.domesileStatus[index] + "_" + this.residencyStatus[index];
    //     let choiseCollege = {
    //       name: name,
    //       stateCode: stateCode,
    //       ipedsId: ipedsId,
    //       domicileAndResidency: domicileAndResidency,
    //       affinityQuestions: affinityQuestion,
    //       awardLetterResultId: awardLetterResultId,
    //     };

    //     let clgSelection =
    //       this.selectedUniversityList[index]["StudentSelectedCollege"];
    //     StudentSelectedCollege.push(clgSelection);
    //     selectedColleges.push(choiseCollege);
    //   }

    //   let StudentList = {
    //     top5_request: true,
    //     formfilledId: this.globalvar.formFilledSubmitID,
    //     SelectCollege: selectedColleges,
    //   };
    //   var encrypted = this.set("govirtue@123", JSON.stringify(StudentList));
    //   const encrypted_split = encrypted.split("/");
    //   const ect_string = encrypted_split.join("***");
    //   let hostname = "";
    //   if (
    //     window.location.hostname == "tech.virtueanalytics.com" ||
    //     window.location.hostname == "localhost"
    //   ) {
    //     hostname = "https://tech.virtueanalytics.com/mse2";
    //   }
    //   if (window.location.hostname == "app.virtueanalytics.com") {
    //     hostname = "https://app.virtueanalytics.com/csr";
    //   }
    //   const submissionReportLink =
    //     hostname + "/top5/home/login/0/" + ect_string;
    //   this.globalvar.submissionReportLink = submissionReportLink;
    //   this.apiService.top5UserSubmission(
    //     formSubmitId,
    //     selectedColleges,
    //     submissionReportLink,
    //     (resp) => {
    //       if (resp) {
    //       }
    //     }
    //   );
    // });
    this.sendSelectedUniversityData();
  
  }

  selectUniversity(type: string, index: number, value: any) {
    this.spinnerService.show();

    this.isLoadingData=true;
    this.apiService.getCollegeProfileById1(value,res=> {
      this.selectedUniversityList[index] = res;
      this.selectedUniversity[index] = value;
      this.isSelectedUniversityItems[index] = false;

      this.setStateInoutMap(
        index,
        this.selectedUniversityList[index].stateCode.toLowerCase()
      );
      if (
        this.selectedUniversityList[index].yearWiseAffinityQuestion &&
        this.selectedUniversityList[index].yearWiseAffinityQuestion["2022"]
      ) {
        this.setAffinityQuestionDefaultAnswer(
          this.selectedUniversityList[index].yearWiseAffinityQuestion["2022"],
          index
        );

        this.yearWiseAffinityQuestion[index] =
          this.selectedUniversityList[index].yearWiseAffinityQuestion["2022"];
      } else {
        this.yearWiseAffinityQuestion[index] = [];
      }
      let housingNotAvailable: boolean = false;
      housingNotAvailable =
        this.selectedUniversityList[index]["housingNotAvailable"];

      if (housingNotAvailable != undefined) {
        if (housingNotAvailable == true) {
          this.selectDomicileAndResidency(
            "residencyDropdown",
            index,
            "OFF_CAMPUS_NOT_FAMILY"
          );
        } else {
          this.selectDomicileAndResidency(
            "residencyDropdown",
            index,
            "ON_CAMPUS"
          );
        }
        //  }
      }

      this.selectDomicileAndResidency(
        "domicileToggle",
        index,
        this.setToggleIn[index]
      );

      this.spinnerService.hide();
    });
  }

  setStateInoutMap(i: number, stateCode: string) {
    if (this.studentInputdata.value == stateCode) {
      this.setToggleIn[i] = true;
    } else {
      this.setToggleIn[i] = false;
    }
  }
  //  setStateInoutMap(i: number, stateCode: string) {
  //   let stateInOut = "";
  //   if (this.studentInputdata.value != undefined) {
  //     if (this.studentInputdata.value == stateCode) {
  //       stateInOut = "IN_STATE";
  //     } else {
  //       stateInOut = "OUT_STATE";
  //     }

  //     let stateAnswer = {
  //       stateCode: stateCode,
  //       stateInOut: stateInOut,
  //     };
  //     this.StateInOutMap.set("state1" + i, stateAnswer);
  //     this.StateInOutMap = new Map(this.StateInOutMap);
  //     this.globalvar.StateInOutMap = this.StateInOutMap;
  //   }
  // }

  setUniversitySelectedValues(index: string, value: string) {
    this.universitySelectedValueMap.set(index, value);
    this.universitySelectedValueMap = new Map(this.universitySelectedValueMap);
    this.globalvar.universitySelectedValueMap = this.universitySelectedValueMap;
  }

  checkedIfState(fieldType: string, index: number) {
    let checked: boolean = false;
    if (fieldType == "domicileToggle") {
      let getStateAnswerMap = this.StateInOutMap.get("state1" + index);
      if (getStateAnswerMap) {
        if (
          getStateAnswerMap.stateCode == this.studentInputdata.value &&
          getStateAnswerMap.stateInOut != "OUT_STATE"
        ) {
          this.setToggleIn[index] = true;
          checked = true;
          return true;
        } else if (
          getStateAnswerMap.stateCode != this.studentInputdata.value &&
          getStateAnswerMap.stateInOut != "OUT_STATE"
        ) {
          this.setToggleIn[index] = true;
          checked = true;
          return true;
        } else {
          this.setToggleIn[index] = false;
          checked = false;
          return false;
        }
      }

      // return checked;
    }
  }

  setInterestPageAnswer(
    index: string,
    selectedValue: string,
    list: any,
    selectedLabel: any
  ) {
    let ans = {
      defaultLabel: selectedLabel,
      defaultValue: selectedValue,
      list: list,
    };
    this.interestPageAnswerMap.set(index, ans);
    this.interestPageAnswerMap = new Map(this.interestPageAnswerMap);
    this.globalvar.interestPageAnswerMap = this.interestPageAnswerMap;
  }

  setAffinityQuestionDefaultAnswer(
    AffinityQuestionDefaultAnswer: any,
    uIndex: number
  ) {
    for (let index = 0; index < AffinityQuestionDefaultAnswer.length; index++) {
      const affinityQuestion = AffinityQuestionDefaultAnswer[index];

      // let IntrestPageAnswer = this.interestPageAnswerMap.get(
      //   "aq" + uIndex + "-" + index
      // );

      // if (IntrestPageAnswer != undefined) {
      //   if (IntrestPageAnswer.defaultValue) {
      //     this.changeAffinityQuestionOption(
      //       "SetAnswer",
      //       uIndex,
      //       index,
      //       IntrestPageAnswer.defaultValue
      //     );
      //   }
      // } else {
      for (let aindex = 0; aindex < affinityQuestion.options.length; aindex++) {
        const opt = affinityQuestion.options[aindex];
        if (aindex == 1) {
          this.changeAffinityQuestionOption("ChangeAnswer", uIndex, index, opt);
          //  }
          // }
        }
      }
    }
  }

  changeAffinityQuestionOption(
    type: string,
    index: number,
    option: number,
    optionSelected: any
  ) {
    let affinityAnswer;
    if (type == "ChangeAnswer") {
      // this.setInterestPageAnswer(
      //   "aq" + index + "-" + option,
      //   optionSelected.value,
      //   [],
      //   ""
      // );

      affinityAnswer = {
        option: option,
        amount: optionSelected.amount,
      };

      optionSelected = optionSelected.value;
      let curData = this.affinityQuestionAnswer.get(
        "aq" + index + "-" + option
      );
      if (curData) {
        curData = { ...curData, ...{ [option]: affinityAnswer } };
      } else {
        curData = { [option]: affinityAnswer };
      }

      this.getAffinityQustionAnswerMap(index, option, curData);
    }
    if (type == "SetAnswer") {
      optionSelected = optionSelected;
    }

    // let affinityobject = this.affinityQuestionAnswer.get(
    //   "aq" + index + "-" + option
    // );
    // if (affinityobject != undefined) {
    // let totalamt = 0;
    // if (affinityobject)
    //   Object.keys(affinityobject).forEach((key) => {
    //     totalamt += affinityobject[key].amount;
    //   });

    this.selectedUniversityList[index].yearWiseAffinityQuestion["2022"][
      "AffinityQuestionSelectedOption"
    ] = optionSelected;
    this.selectedUniversityList[index].yearWiseAffinityQuestion["2022"][option][
      "AffinityQuestionSelectedOption"
    ] = optionSelected;

    let totalamt = 0;
    if (
      this.selectedUniversityList[index].yearWiseAffinityQuestion["2022"].length
    )
      this.selectedUniversityList[index].yearWiseAffinityQuestion[
        "2022"
      ].forEach((key) => {
        // totalamt += affinityobject[key].amount;

        key.options.forEach((element) => {
          if (element.value === key["AffinityQuestionSelectedOption"]) {
            totalamt += element.amount;
          }
        });
      });

    this.selectedUniversityList[index].yearWiseAffinityQuestion["2022"][
      "AffinityQuestionSelectedAmount"
    ] = totalamt;

    this.createAffinityQuestions(index, optionSelected);
    //}
  }

  createAffinityQuestions(index: number, optionSelected: String) {
    let affinityQuestion =
      this.selectedUniversityList[index].yearWiseAffinityQuestion["2022"];
    for (let aindex = 0; aindex < affinityQuestion.length; aindex++) {
      const element = affinityQuestion[aindex];
      const selected = element?.AffinityQuestionSelectedOption;
      for (let opt = 0; opt < element.options.length; opt++) {
        const value = element.options[opt];

        if (value.value == selected) {
          this.selectedUniversityList[index].yearWiseAffinityQuestion["2022"][
            aindex
          ].options[opt]["selected"] = true;
        } else {
          this.selectedUniversityList[index].yearWiseAffinityQuestion["2022"][
            aindex
          ].options[opt]["selected"] = false;
        }
      }
    }
  }

  getAffinityQustionAnswerMap(index: number, option: number, curData: any) {
    let aindex = "aq" + index + "-" + option;
    this.affinityQuestionAnswer.set(aindex, curData);
    this.affinityQuestionAnswer = new Map(this.affinityQuestionAnswer);
    this.globalvar.affinityQuestionAnswer = this.affinityQuestionAnswer;
  }

  selectDomicileAndResidency(fieldType: string, index: number, event: any) {
    this.spinnerService.show();
    let ipedsId: string;
    let housingNotAvailable: boolean;
    let domicileAndResidencyStatus: string[] = [];
    if (fieldType === "domicileToggle") {
      if (event) {
        this.domesileStatus[index] = "IN_STATE";
      } else {
        this.domesileStatus[index] = "OUT_STATE";
      }
    } else if (fieldType === "residencyDropdown") {
      this.residencyStatus[index] = event;
    }

    domicileAndResidencyStatus[index] =
      this.domesileStatus[index] + "_" + this.residencyStatus[index];

    ipedsId = this.selectedUniversityList[index]["id"];

    if (
      this.domesileStatus[index] == undefined ||
      this.residencyStatus[index] == undefined
    ) {
      return;
    }
    let affinityQuestion = null;
    if (
      this.selectedUniversityList[index]?.yearWiseAffinityQuestion["2022"] !=
      undefined
    ) {
      // this.affinitySelectedItems=[];
      affinityQuestion =
        this.selectedUniversityList[index]?.yearWiseAffinityQuestion["2022"];
      //   this.affinitySelectedItems=affinityQuestion;
    }

    let stateCode = this.selectedStates[index];
    let StudentSelectedCollege = {
      domicileAndResidency:
        this.domesileStatus[index] + "_" + this.residencyStatus[index],
      ipedsId: ipedsId,
      stateCode: stateCode,
      affinityQuestion: affinityQuestion,
    };
    this.selectedUniversityList[index]["StudentSelectedCollege"] =
      StudentSelectedCollege;

    this.apiService
      .getCollegeIpedsCost1(ipedsId, domicileAndResidencyStatus[index],this.selectedUniversityList[index].statCode,
        res=> {
          this.selectedUniversityList[index]["ipedsCost"] = res["costs"];
          // this.hideSpinner();
          // this.getMeritScholarShipCombindData(
          //   index,
          //   ipedsId,
          //   domicileAndResidencyStatus[index]
          // );
        }
      );

   

  }

  setStateInOutToggaleOptionsAnswerMap(
    fieldType: string,
    index: number,
    stateInOut: string
  ) {
    // if (
    //   fieldType == "domicileToggleChange" ||
    //   fieldType == "residencyDropdownChange"
    // ) {

    let getStateAnswerMap = this.StateInOutMap.get("state" + index);
    if (getStateAnswerMap) {
      let stateAnswer = {
        stateCode: getStateAnswerMap.stateCode,
        stateInOut: stateInOut,
      };
      this.StateInOutMap.set("state" + index, stateAnswer);
      this.StateInOutMap = new Map(this.StateInOutMap);
      this.globalvar.StateInOutMap = this.StateInOutMap;
    }
    // } else {

    // }
  }

  setByCourseCollegeWiseProgramList(index: number, ipedsId: string) {
    let studentProgram = this.answerMap.get(35);
    this.apiService
      .getCollegeWiseProgramData1(ipedsId, studentProgram.value,ProgramList => {
          if (
            ProgramList?.programCategoryDataPresent == true &&
            ProgramList?.collegeDataPresent == true
          ) {
            this.selectedUniversityList[index]["CollegeWiseProgramList"] =
              ProgramList;
            // this.hideSpinner();
           this.isLoadingData=false;
           this.sendSelectedUniversityData();
           this.cdr.detectChanges();

          }
          else
          {
            this.selectedUniversityList[index]["CollegeWiseProgramList"] =
            null;
          // this.hideSpinner();
         this.isLoadingData=false;
         this.sendSelectedUniversityData();
         this.cdr.detectChanges();

          }
        }
   
      );
  }

  hideSpinner() {
    return setTimeout(() => {
      // this.isLoadingData=false;
      return this.spinnerService.hide();
    }, 1500);
  }

  // getMeritScholarShipCombindData(
  //   collegeIndex: number,
  //   ipedsId: string,
  //   domicileAndResidencyStatus: string
  // ) {
  //   let efc = this.answerMap.get(40);
  //   // let act = this.answerMap.get(202);
  //   let gpa = "";
  //   let gpaScale = this.answerMap.get(266);
  //   let actdropdown = this.answerMap.get(32);
  //   let act = "";
  //   let sat = "";
  //   if (actdropdown.value == "act") {
  //     let scoreact = this.answerMap.get(202);
  //     act = scoreact.value;
  //   }
  //   if (actdropdown.value == "sat") {
  //     let scoresct = this.answerMap.get(201);
  //     sat = scoresct.value;
  //   }
  //   if (gpaScale.value == "4") {
  //     let gpaValue = this.answerMap.get(31);
  //     gpa = gpaValue.value;
  //   }
  //   if (gpaScale.value == "5") {
  //     let gpaValue = this.answerMap.get(271);
  //     gpa = gpaValue.value;
  //   }
  //   if (gpaScale.value == "12") {
  //     let gpaValue = this.answerMap.get(275);
  //     gpa = gpaValue.value;
  //   }
  //   if (gpaScale.value == "100") {
  //     let gpaValue = this.answerMap.get(276);
  //     gpa = gpaValue.value;
  //   }
  //   let state = this.answerMap.get(6);

  //   this.apiService
  //     .getMeritScholarShipCombindData1(
  //       ipedsId,
  //       efc.value,
  //       act,
  //       sat,
  //       gpa,
  //       state.value,
  //       domicileAndResidencyStatus
  //     ,meritData=> {
  //       this.selectedUniversityList[collegeIndex]["result"] = meritData;
  //       // this.hideSpinner();
  //   this.setByCourseCollegeWiseProgramList(collegeIndex, ipedsId);

  //     });
  // }

  sendSelectedUniversityData() {
    this.mergerdUniversityList = [];
        for (let index = 0; index < this.selectedUniversityList.length; index++) {
      if (this.selectedUniversityList[index] == undefined) continue;
      let obj = {} as any;
      let dropDownDataObject = {} as any;
      obj.id = this.selectedUniversityList[index]["id"];
      obj.name = this.selectedUniversityList[index]["name"];
      obj.StudentSelectedCollege =
        this.selectedUniversityList[index]["StudentSelectedCollege"];
      obj.ipedsId = this.selectedUniversityList[index]["ipedsId"];
      obj.costOfAttendance = this.selectedUniversityList[index]["ipedsCost"];
      obj.result = this.selectedUniversityList[index]["result"];

      if (
        this.selectedUniversityList[index]["CollegeWiseProgramList"] !=
        undefined
      ) {
        obj.CollegeWiseProgramList =
          this.selectedUniversityList[index]["CollegeWiseProgramList"];
      }

      let domicileAndResidency =
        this.domesileStatus[index] + "_" + this.residencyStatus[index];

      let name = this.selectedUniversityList[index]["name"];
      let ipedsId = this.selectedUniversityList[index]["ipedsId"];

      obj.yearWiseAffinityQuestion =
        this.selectedUniversityList[index]["yearWiseAffinityQuestion"];
      for (const item of this.selectedUniversityList[index]["ipedsCost"]) {
        obj[item.name] = item.value;
      }

      if (
        this.selectedUniversityList[index]["analysisData"] != null &&
        this.selectedUniversityList[index]["analysisData"]
      ) {
        Object.entries(this.selectedUniversityList[index]["analysisData"]).map(
          (entry) => {
            let key = entry[0];
            let value = entry[1];
            obj[key] = value;
          }
        );
      }

      dropDownDataObject = { dropDownData: obj };
      this.mergerdUniversityList[index] = dropDownDataObject;

      let objSummary = {} as any;
      //let summaryDataObject = {} as any;
      objSummary.lastSupportedSession =
        this.selectedUniversityList[index]["lastSupportedSession"];
      objSummary.dataCollectionTime =
        this.selectedUniversityList[index]["dataCollectionTime"];

      if (this.selectedUniversityList[index]?.importantLink?.npc) {
        objSummary.npcLink =
          this.selectedUniversityList[index]["importantLink"]["npc"];
      } else {
        objSummary.npcLink = null;
      }
      if (this.selectedUniversityList[index]?.importantLink?.financialAid) {
        objSummary.financialAid =
          this.selectedUniversityList[index]["importantLink"]["financialAid"];
      } else {
        objSummary.financialAid = null;
      }

      if (this.selectedUniversityList[index]?.importantLink?.website) {
        objSummary.website =
          this.selectedUniversityList[index]["importantLink"]["website"];
      } else {
        objSummary.website = null;
      }

      if (this.selectedUniversityList[index]?.contact?.contactNumber) {
        objSummary.contact =
          this.selectedUniversityList[index]["contact"]["contactNumber"];
      } else {
        objSummary.contact = null;
      }
      if (this.selectedUniversityList[index]?.contact?.address) {
        objSummary.address =
          this.selectedUniversityList[index]["contact"]["address"];
      } else {
        objSummary.address = null;
      }

      let year = "2022";

      if (
        this.selectedUniversityList[index]?.yearWiseCollegeData ==
        ({} as object)
      ) {
        objSummary.inStateTutionFee = null;
        objSummary.outStateTutionFee = null;
      } else {
        if (
          !this.selectedUniversityList[index]["yearWiseCollegeData"] ||
          !this.selectedUniversityList[index]["yearWiseCollegeData"][year]
        ) {
          objSummary.inStateTutionFee = this.selectedUniversityList[index][
            "datafields"
          ].find((element) => element.fieldNo == 51)["value"];
          objSummary.outStateTutionFee = this.selectedUniversityList[index][
            "datafields"
          ].find((element) => element.fieldNo == 135)["value"];
        } else {
          if (
            this.selectedUniversityList[index] &&
            this.selectedUniversityList[index]["yearWiseCollegeData"] !=
              ({} as object) &&
            this.selectedUniversityList[index]["yearWiseCollegeData"][year]
          ) {
            const data51 = this.selectedUniversityList[index][
              "yearWiseCollegeData"
            ][year].find((element) => element.fieldNo == 51);
            if (data51) {
              objSummary.inStateTutionFee = data51["value"];
            }
            const data = this.selectedUniversityList[index][
              "yearWiseCollegeData"
            ][year].find((element) => element.fieldNo == 135);
            if (data) {
              objSummary.outStateTutionFee = data["value"];
            }
          }
        }
      }
      // summaryDataObject = { "summaryData": objSummary };
      // this.mergerdUniversityList[index] = summaryDataObject;
      this.mergerdUniversityList[index]["summaryData"] = objSummary;
    }
    for (let index = 0; index < this.ocrResponseListTotal.length; index++) {
      let ocrDataScholarshipItems = {} as any;
      let ocrDataCoaItems = {} as any;
      let additionOfDetectedScholarshipValues: number = 0;
      let additionOfDetectedCoaValues: number = 0;
      if (this.ocrResponseListTotal[index] == undefined) continue;
      //if(this.ocrResponseListTotal[index]){ }
      ocrDataCoaItems = this.createOcrDataObject(
        this.ocrResponseListTotal[index],
        "1"
      );
      ocrDataScholarshipItems = this.createOcrDataObject(
        this.ocrResponseListTotal[index],
        "2"
      );
      for (const item of this.ocrResponseListTotal[index]["detectedValues"]) {
        if (item.mapWith === "1") {
          additionOfDetectedCoaValues += +item.value;
        } else if (item.mapWith === "2") {
          additionOfDetectedScholarshipValues += +item.value;
        }
      }

      for (
        let indexMerged = 0;
        indexMerged < this.mergerdUniversityList.length;
        indexMerged++
      ) {
        if (this.mergerdUniversityList[indexMerged] == undefined) continue;
        if (
          ocrDataScholarshipItems.id ===
          this.mergerdUniversityList[indexMerged]["dropDownData"].id
        ) {
          if (ocrDataCoaItems != undefined) {
            this.mergerdUniversityList[indexMerged]["ocrDataCoaItems"] =
              ocrDataCoaItems;
          }

          this.mergerdUniversityList[indexMerged]["ocrDataScholarshipItems"] =
            ocrDataScholarshipItems;
          this.mergerdUniversityList[indexMerged]["ocrDataCoaSum"] =
            additionOfDetectedCoaValues;
          this.mergerdUniversityList[indexMerged]["ocrDataScholarshipsSum"] =
            additionOfDetectedScholarshipValues;
        }
      }
    }
    let mergerdUniversityListOnlyNotEmpty = this.mergerdUniversityList.filter((element) => element != "empty"
    );

   // this.changedCollege[c]
   this.searchSelectedCollegeList[this.selctedCollegeIndex]=this.changedCollege;
  //  this.searchSelectedCollegeList.splice(this.selctedCollegeIndex,1);

    let obj ={
      searchedColleges:this.searchSelectedCollegeList,
      selectedColleges:mergerdUniversityListOnlyNotEmpty
    }
    this.context.completeWith(obj);
    // this.context.completeWith("");
    // this.cdr.detectChanges();

    // this.optionData.emit(mergerdUniversityListOnlyNotEmpty);
    // this.cdkStepper.next();
  }

  createOcrDataObject(ocrDataItem, mapIdValue: string) {
    let obj = {} as any;
    let selectedUniversityItem = this.selectedUniversityList.find(
      (item) => item != undefined && item.name == ocrDataItem.extraText
    );
    obj.id = selectedUniversityItem["id"];
    obj.name = selectedUniversityItem["name"];
    obj.ipedsId = selectedUniversityItem["ipedsId"];
    if (
      ocrDataItem["detectedValues"].some((item) => item.mapWith === mapIdValue)
    ) {
      //let selectedUniversityItem = this.allUniversityList.find(item =>item.name==ocrDataItem.extraText);
      //let additionOfDetectedValues=0;
      for (const item of ocrDataItem["detectedValues"]) {
        if (item.mapWith === mapIdValue) {
          obj[item.fieldName] = item.value;
        }

        //additionOfDetectedValues+= +item.value;
      }
    }
    //obj.sumOfDetectedValues=additionOfDetectedValues;

    return obj;
  }

  checkDisableNextBtn() {
    if (this.selctedCollege != undefined && this.isLoadingData==false) {
      return false;
    } else {
      return true;
    }
  }

  onSelected(item: any, selectedIndex: number) {
   // this.selectedUniversityList=[];
    let selctedCollege=[];
    this.selctedCollegeIndex = selectedIndex;
    this.selctedCollege = item;
    // this.selectUniversity("", 0, item.key);
    this.searchSelectedCollegeList.forEach((data,index) => {
      
      if(data?.dropDownData?.ipedsId==item.key)
      {
        selctedCollege=data;
        this.searchSelectedCollegeList[selectedIndex]=this.changedCollege;

      }
    });

    let obj ={
      searchedColleges:this.searchSelectedCollegeList,
      selectedColleges:selctedCollege
    }
    this.context.completeWith(obj);
  }
  close() {

    this.context.completeWith("");
    const dialog = document.querySelector('tui-dialog');
    dialog.classList.remove('replace-college');
  }
}
